import React from 'react'
import styled from 'styled-components'
import CourseUnits from './CourseUnits'

export default function CourseContent({ course }) {
  return (
    <CourseContentWrapper className="section main-content">
      <div className='section-content normal-padding'>
        <div className='row two-thirds-width'>
          <div className='column course-main-content'>
            <div className='content-units'>
              <h3>What's Inside:</h3>
              <CourseUnits units={course.units} />
            </div>
            <div className='content-info'>
              {course.instructors && course.instructors.length > 0 && (
                <div className='course-instructor'>
                  <h6>Course Instructor</h6>
                  <ul className="instructors">
                    {course.instructors.map((instructor) => (
                      <li key={instructor.name} className="instructor">{instructor.name}</li>
                    ))}
                  </ul>
                </div>
              )}
              {course.post_content && (
                <div className="content-description" dangerouslySetInnerHTML={{__html: course.post_content}} />
              )}
            </div>    
          </div>
        </div>
      </div>
    </CourseContentWrapper>
  )
}

const CourseContentWrapper = styled.section`
  background: ${({theme}) => theme.background};
  color: ${({theme}) => theme.text};
`